/**
 * Enter or leave kiosk mode — available to any report, from its toolbar.
 *
 * The URL parameter is what a wall screen is bookmarked with; this is what everyone else uses,
 * and it doubles as the way out for a reader who arrived on a chrome-free page and wants the menu
 * back. Both routes go through `useKioskMode`, so there is one definition of what kiosk means.
 */

import { faCompress, faExpand } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { useKioskMode } from '@/hooks/useKioskMode';
import { useI18n } from '@/lib/i18n';

export function KioskToggle({ className }: { className?: string }) {
  const { text } = useI18n();
  const { isKiosk, toggle } = useKioskMode();
  const label = text(isKiosk ? 'Leave full screen' : 'Show full screen');

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          aria-label={label}
          aria-pressed={isKiosk}
          onClick={toggle}
          className={className}
        >
          <FontAwesomeIcon icon={isKiosk ? faCompress : faExpand} className="size-4" aria-hidden />
        </Button>
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
}
